import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import CreateEditHoliday from './CreateEditHoliday'

import {
    fetchHolidaysList,
    fetchHoliday,
    fetchHolidayErrorClear,
    fetchHolidayError,
    createHoliday,
    updateHoliday,
    errorHoliday
} from './actions'

import Moment from 'moment';

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Holidays.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Holidays extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editHolidayMode: false,
            viewMode: false,
            date: null,
            nameSrch: '',
            holiday: {
                name: '',
                holidayDate: '01/01/0000',
                holidayTypeId: '0',
                message: ''
            },
        };

        this.fetchHolidayErrorClear = this.fetchHolidayErrorClear.bind(this);
        this.errorHolidayClear = this.errorHolidayClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.search = this.search.bind(this);

        this.holidayEdit = this.holidayEdit.bind(this);
        this.holidayEditVerify = this.holidayEditVerify.bind(this);

        this.holidayCreate = this.holidayCreate.bind(this);

        this.updateHoliday = this.updateHoliday.bind(this);
        this.cancelHoliday = this.cancelHoliday.bind(this);
        this.closeHoliday = this.closeHoliday.bind(this);

        this.holidayView = this.holidayView.bind(this);
        this.viewModeVerify = this.viewModeVerify.bind(this);

        this.holidayCheck = this.holidayCheck.bind(this);
        this.afterOpen = this.afterOpen.bind(this);
    }

    formatDateTime(date) {
        return new Date(date).toISOString().slice(0, 10);
    }

    fetchHolidayErrorClear() {
        this.props.dispatch(fetchHolidayError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    onChange() {
        alert($('.fox').val());
       this.setState({ date: $('.fox').val() })
    }

    afterOpen() {
        this.holidayCheck();
    }

    holidayCheck() {

        if ($('#holiday_name').val().length === 0 || $('#holiday_type').val() === "0" || $('#holiday_date').val() === "" || $('#holiday_message').val() === ""  || this.state.viewMode === true)
            $('button.modbrick').attr("disabled", "disabled")
        else
            $('button.modbrick').removeAttr("disabled")
    }

    errorHolidayClear(e) {
        this.props.dispatch(errorHoliday);

        if (this.props.holiday.error === "409") {
            let id = e.target.attributes.holiday.id;

           fetchHoliday.bind(this)(id, false);
        }
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() })
    }

    holidayEdit(e) {

        if (chkReturn || this.props.holidays.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.holiday.value;
        this.setState({
            holiday: {
                name: '',
                holidayDate: '01/01/0000',
                holidayTypeId: '0',
                message: ''
           }
         });


        fetchHoliday.bind(this)(id, false);

        chkReturn = setInterval(this.holidayEditVerify, 500);
    }
    holidayEditVerify() {
        if (this.props.holiday.updated || this.props.holiday.error) {
            this.setState({
                value: -1,
                editHoliday: true,
                editHolidayMode: true
            });

            $('.navbar-static-top').css('z-index', 0);
        }

        clearInterval(chkReturn);
        chkReturn = 0;
    }

    holidayCreate() {
        if (this.props.holidays.fetching) return

        fetchHoliday.bind(this)(0, true);

        let emptyHoliday = {
            name: '',
            holidayDate: '01/01/0000',
            holidayTypeId: '0',
            message: ''
        };

        this.setState({
            holiday: emptyHoliday,
            editHoliday: false,
            editHolidayMode: true
        });



        $('.navbar-static-top').css('z-index', 0);
    }

    holidayView(e) {
        if (chkReturn || this.props.holidays.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.holiday.value;

        this.setState({
            holiday: {
                name: '',
                holidayDate: '01/01/0000',
                holidayTypeId: '0',
                message: ''
            }
        });


         fetchHoliday.bind(this)(id, false);
         

        chkReturn = setInterval(this.viewModeVerify, 500);
    }

    viewModeVerify() {
        this.setState({
            value: -1,
            editHoliday: true,
            editHolidayMode: true,
            viewMode: true
        });
        $('.navbar-static-top').css('z-index', 0);
        clearInterval(chkReturn);
        chkReturn = 0;
    }

    updateHoliday(e) {
        $('button.modbrick').attr('disabled', 'disabled')

        let create = e.target.attributes.create.value;
        let holiday = {
            name: $('#holiday_name').val().trim(),
            holidayDate: $('#holiday_date').val(),
            holidayTypeId: $('#holiday_type').val(),
            message: $('#holiday_message').val()
        };

        if (create === 'true') {
            createHoliday.bind(this)(holiday);
        }
        else {
            holiday.HolidayId = parseInt($('#holiday_id').text());
            updateHoliday.bind(this)(holiday.HolidayId, holiday);
        }

        chkReturn = setInterval(this.closeHoliday, 100);
    }
    cancelHoliday() {
        this.props.dispatch(errorHoliday);

        this.setState({
            editHolidayMode: false,
            viewMode: false 
        });

        this.props.dispatch(fetchHolidaysList);
    }
    closeHoliday() {
        if (this.props.holiday.updated || this.props.holiday.error) {
            $('button.modbrick').removeAttr('disabled')

            if (this.props.holiday.updated) {
                this.cancelHoliday();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    render() {

        let rowStyle = {
            color: "gray"
        };

        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() - 1);
        tomorrow.setHours(0);
        tomorrow.setMinutes(0);
        tomorrow.setMilliseconds(0);

        return (
            <div className="holidays-groups col-xs-12">
                <CommError error={this.props.holiday.error} onClose={this.errorHolidayClear} />
                <CommError error={this.props.holidays.error} onClose={this.fetchHolidayErrorClear} />

                <ConfirmModal open={this.props.holidays.noData} heading={"Holidays"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="holidays ">
                        <h1>Holidays</h1>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.holidays.fetching ?
                            <input id="name" autocomplete="off" spellcheck="false" disabled />
                        :
                            <input id="name" autocomplete="off" spellcheck="false" onChange={this.search} />
                    }
                    <button onClick={this.holidayCreate} className="btn btn-primary pull-right"> + Create Holiday </button>
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.holidays.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Holiday</th>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.holidays ?
                                    this.props.holidays.holidaysList.filter((holiday) => {
                                        if (this.state.nameSrch.length) {
                                            if (holiday.name.toLowerCase().startsWith(this.state.nameSrch)) {
                                                holiday.prefix = holiday.name.substring(0, this.state.nameSrch.length)
                                                holiday.suffix = holiday.name.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else return false
                                        }
                                        else return true
                                    }).map((holiday, index) => { 
                                        if (new Date(holiday.holidayDate) < tomorrow)
                                        {
                                            return <tr style={rowStyle} className="body" key={index}>
                                                <td className="name" holiday={holiday.id} onClick={this.holidayView}>
                                                    {this.state.nameSrch.length ? <p><span className="srch">{holiday.prefix}</span><span>{holiday.suffix}</span></p> : holiday.name}
                                                </td>
                                                <td>{this.formatDateTime(holiday.holidayDate)}</td>
                                                <td>{holiday.holidayTypeName}</td>
                                                <td>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                        <i className="fa fa-edit" holiday={holiday.id} onClick={this.holidayEdit}></i>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        }
                                        else {
                                            return <tr className="body" key={index}>
                                                <td className="name" holiday={holiday.id} onClick={this.holidayView}>{holiday.name}</td>
                                                <td>{this.formatDateTime(holiday.holidayDate)}</td>
                                                <td>{holiday.holidayTypeName}</td>
                                                <td>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                        <i className="fa fa-edit" holiday={holiday.id} onClick={this.holidayEdit}></i>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        }
                                    })
                                : null
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditHoliday
                    errHoliday={this.props.holiday}
                    errHolidayClear={this.errorHolidayClear}
                    curHoliday={this.props.holiday.holiday}
                    holidayTypes={this.props.holiday}
                    tmpHoliday={this.state.holiday}
                    viewMode={this.state.viewMode}
                    create={this.state.editHoliday}
                    isOpen={this.state.editHolidayMode}
                    newDate={this.state.date}
                    newValue={this.onChange.bind(this)}
                    valuesCheck={this.holidayCheck}
                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateHoliday}
                    onRequestCancel={this.cancelHoliday}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    holiday: state.holiday,
    holidays: state.holidays
});

export default connect(mapStateToProps)(Holidays)